import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';

import { setMethodology } from '../../actions';

const GeneralInformation = props => {

	useEffect(() => {
		// set Methodology to osh context - OSH Authorities
		props.setMethodology('osh-context', 'OSH authorities', 27)

		// Update the title of the page
		document.title = props.literals.L22019 +  " - " + props.literals.L22020 + " - " + props.literals.L363;
	}, [])

	return(
		<div className="about-tool">
			<div className="container">
				<h1 className="title-section second-color text-center">{props.literals.L22019}</h1>
				<h2>{props.literals.L20735}</h2>
				<section className="about-tool-content">
					{ReactHtmlParser(props.literals.L20737)}
					<p>
						<img className='core-scheme' src={require("../../style/img/core-scheme.png")}></img>
					</p>
					{ReactHtmlParser(props.literals.L20832)}
				</section>
				<p className="btn--wrapper text-center">
					<Link className="btn-default btn-main-color text-center" to={'/about-the-system/methodology'} >{props.literals.L20736}</Link>
				</p>
			</div>
		</div>
	)
}

function mapDispatchToProps(dispatch) {
	return {
		setMethodology: (section, subSection, indicator) => dispatch(setMethodology(section, subSection, indicator))
	}
}

GeneralInformation.displayName = 'GeneralInformation';
export default connect(null, mapDispatchToProps)(GeneralInformation);